<template>
	<div>
		<v-flex>
			<v-card>
				<v-card-title class="mt-4 mb-3">
					<h2>Status naboru: {{getContestStatus()}}, Status oceny: {{getEvaluationStatus()}}</h2>
					<h2></h2>
					<v-spacer/>
				</v-card-title>
				<div
					v-if="(contestAnnouncementStatus === 'NEW' || contestAnnouncementStatus === 'ANNOUNCEMENT_UNDONE')">
					<div>
						<v-btn class="ml-3" @click="announceContest" color="default">
							Opublikuj nabór
						</v-btn>
					</div>
				</div>
				<div>
					<div v-if="contestAnnouncementStatus === 'ANNOUNCED'">
						<v-btn class="ml-3" @click="closeContest" color="default">
							Cofnij publikację naboru
						</v-btn>
						<v-btn class="ml-1" @click="finishContest" color="default" v-if="contestStatus === 'FINISHED'">
							Zakończ nabór
						</v-btn>
					</div>
					<div>
						<v-btn class="ml-3" @click="startEvaluation" v-if="contestStatus === 'NOT_STARTED'" color="default">
							Rozpocznij ocenę wniosków
						</v-btn>
					</div>
				</div>
				<div v-if="contestStatus === 'STARTED'">
					<div>
						<v-btn class="ml-3" @click="undoEvaluation" color="default">
							Cofnij ocenę wniosków
						</v-btn>
						<v-btn class="ml-1" @click="finishEvaluation" color="default">
							Zakończ ocenę wniosków
						</v-btn>
					</div>
				</div>
				<div v-if="contestStatus === 'FINISHED' && contestAnnouncementStatus !== 'FINISHED'">
					<div>
						<v-btn class="ml-3" @click="undoEvaluationFinish" color="default">
							Cofnij zakończenie oceny
						</v-btn>
					</div>
				</div>
			</v-card>
		</v-flex>

		<egranty-error-list-popup
			title="Nie udało się otworzyć naboru:"
			:error-list="agencyContestOpeningErrors.messages"
			:is-open="agencyContestOpeningErrors.showPopup"
			@close="closeAgencyContestOpeningErrorsPopup"
		/>

		<egranty-error-list-popup
			title="Nie udało się rozpocząć oceny:"
			:error-list="evaluationStartErrors.messages"
			:is-open="evaluationStartErrors.showPopup"
			@close="closeEvaluationStartErrorsPopup"
		/>

		<egranty-error-list-popup
			title="Nie udało się zakończyć oceny:"
			:error-list="evaluationFinishErrors.messages"
			:is-open="evaluationFinishErrors.showPopup"
			@close="closeEvaluationFinishErrorsPopup"
		/>
	</div>
</template>

<script>
	import EgrantyErrorListPopup from "../../../genericComponents/EgrantyErrorListPopup";
	import {Api} from "../../../api";
	import {AgencyContest} from "../../../api/generated/AgencyContest";

	export default {
		name: "AgencyContestActionView",
		components: {EgrantyErrorListPopup},

		data () {
			return {
				contestAnnouncementStatus: null,
				contestStatus: null,
				agencyContestOpeningErrors: {
					showPopup: false,
					messages: [],
				},
				evaluationStartErrors: {
					showPopup: false,
					messages: [],
				},
				evaluationFinishErrors: {
					showPopup: false,
					messages: [],
				}
			};
		},

		created () {
			this.refresh();
		},

		methods: {
			refresh () {
				this.contestStatus = AgencyContest.getState(this, this.$route.params.id, response => {
					this.contestAnnouncementStatus = response.agencyContestAnnouncementStatus;
					this.contestStatus = response.agencyContestStatus;
				});
			},

			getEvaluationStatus () {
				if (this.contestStatus === "NOT_STARTED") {
					return "Nierozpoczęta";
				} else if (this.contestStatus === "STARTED") {
					return "Rozpoczęta";
				} else if (this.contestStatus === "FINISHED") {
					return "Zakończona";
				} else {
					return "-";
				}
			},

			getContestStatus () {
				if (this.contestAnnouncementStatus === "NEW") {
					return "Nowy, nieopublikowany";
				} else if (this.contestAnnouncementStatus === "ANNOUNCEMENT_UNDONE") {
					return "Publikacja cofnięta";
				} else if (this.contestAnnouncementStatus === "ANNOUNCED") {
					return "Opublikowany";
				} else if (this.contestAnnouncementStatus === "FINISHED") {
					return "Zakończony";
				} else {
					return "-";
				}
			},

			generateEvaluationConfirmationMessage (schemaSet) {
				let message = "Oceny i opinie zawarte w naborze: ";
				let schemasIncluded = [];
				if (schemaSet.individualEvaluationSchemaIncluded) {
					schemasIncluded.push("indywidualna opinia członka zespołu");
				}
				if (schemaSet.expertEvaluationSchemaIncluded) {
					schemasIncluded.push("opinia eksperta");
				}
				if (schemaSet.finalEvaluationSchemaIncluded) {
					schemasIncluded.push("opinia końcowa");
				}
				message = schemasIncluded.length === 0 ?
					message = message.concat(" brak. Rozpoczęcie oceny wniosków w przypadku niezdefiniowanych ocen indywidualnych powoduje rozpoczęcie posiedzenia komisji") :
					message = message.concat(schemasIncluded.join(", "));
				return message.concat(". Czy na pewno chcesz rozpocząć ocenianie?");
			},

			async startEvaluation () {
				let path = "/agency-contest/all-forms?contestId=" + this.$route.params.id;
				let confirmationMessage;
				await Api.syncGet(this, path, successResponse => {
					confirmationMessage = this.generateEvaluationConfirmationMessage(successResponse.agencyContestSchemaSet);
					this.$confirm(confirmationMessage, {
						color: "blue",
						icon: "warning",
						title: "Rozpoczęcie oceniania",
						width: 600,
					})
						.then(response => {
							if (response) {
								AgencyContest.postOpenEvaluation(this, this.$route.params.id, successResponse => {
										this.$messagesBus.$emit("success", "Ocena została rozpoczęta", successResponse);
										this.refresh();
									},
									errorResponse => {
										this.evaluationStartErrors.messages = errorResponse.message.split("\n");
										this.evaluationStartErrors.messages.pop();
										this.evaluationStartErrors.showPopup = true;
										this.$messagesBus.$emit("error", "Nie udało się rozpocząć oceny", this.snackbarMessage + " " + JSON.stringify(errorResponse));
									});
							}
						});
				});
			},

			undoEvaluation () {
				AgencyContest.postCloseEvaluation(this, this.$route.params.id, successResponse => {
						this.$messagesBus.$emit("success", "Ocena została cofnięta", this.snackbarMessage + " " + JSON.stringify(successResponse));
						this.refresh();
					},
					errorResponse => {
						this.$messagesBus.$emit("error", "Nie udało się cofnąć oceny", this.snackbarMessage + " " + JSON.stringify(errorResponse));
					});
			},

			finishEvaluation () {
				this.$confirm("Czy na pewno chcesz zakończyć ocenę? Po zakończeniu nie będzie możliwości przypisania " +
					"wniosków do oceny. Opiniodawcy nie będą mogli wysłać nieskończonych ocen.", {
					icon: "warning",
					title: "Zakończenie oceny",
					color: "info",
					width: 500,
				})
					.then(response => {
						if (response) {
							AgencyContest.postFinishEvaluation(this, this.$route.params.id, successResponse => {
									this.$messagesBus.$emit("success", "Ocena została zakończona", this.snackbarMessage + " " + JSON.stringify(successResponse));
									this.refresh();
								},
								errorResponse => {
									this.evaluationFinishErrors.messages = errorResponse.message.split("\n");
									this.evaluationFinishErrors.messages.pop();
									this.evaluationFinishErrors.showPopup = true;
									this.$messagesBus.$emit("error", "Nie udało się zakończyć oceny", this.snackbarMessage + " " + JSON.stringify(errorResponse));
								});
						}
					});
			},

			undoEvaluationFinish () {
				AgencyContest.postUndoFinishEvaluation(this, this.$route.params.id, successResponse => {
						this.$messagesBus.$emit("success", "Ocena została ponownie rozpoczęta", this.snackbarMessage + " " + JSON.stringify(successResponse));
						this.refresh();
					},
					errorResponse => {
						this.$messagesBus.$emit("error", errorResponse.message, this.snackbarMessage + " " + JSON.stringify(errorResponse));
					});
			},

			announceContest () {
				AgencyContest.putOpen(this, this.$route.params.id,
					successResponse => {
						this.$messagesBus.$emit("success", "Nabór został otwarty", successResponse);
						this.refresh();
					},
					errorResponse => {
						this.$messagesBus.$emit("error", "Nie udało się poprawnie otworzyć naboru", this.snackbarMessage + " " + JSON.stringify(errorResponse));
						this.agencyContestOpeningErrors.messages = errorResponse.message.split("\n");
						this.agencyContestOpeningErrors.messages.pop();
						this.agencyContestOpeningErrors.showPopup = true;
					});
			},

			closeContest () {
				AgencyContest.putClose(this, this.$route.params.id, successResponse => {
						this.$messagesBus.$emit("success", "Nabór został zamknięty", this.snackbarMessage + " " + JSON.stringify(successResponse));
						this.refresh();
					},
					errorResponse => {
						this.$messagesBus.$emit("error", "Nie udało się poprawnie zamknąć naboru", this.snackbarMessage + " " + JSON.stringify(errorResponse));
					});
			},

			finishContest () {
				this.$confirm("Czy na pewno chcesz zakończyć nabór? Po zatwierdzeniu nie będzie możliwości cofnięcia zakończenia.", {
					icon: "warning",
					title: "Zakończenie naboru",
					color: "info",
					width: 500,
				})
					.then(response => {
						if (response) {
							AgencyContest.putFinish(this, this.$route.params.id, successResponse => {
									this.$messagesBus.$emit("success", "Nabór został zakończony", this.snackbarMessage + " " + JSON.stringify(successResponse));
									this.refresh();
								},
								errorResponse => {
									this.$messagesBus.$emit("error", errorResponse.message, this.snackbarMessage + " " + JSON.stringify(errorResponse));
								});
						}
					});
			},

			closeAgencyContestOpeningErrorsPopup () {
				this.agencyContestOpeningErrors.showPopup = false;
			},

			closeEvaluationStartErrorsPopup () {
				this.evaluationStartErrors.showPopup = false;
			},

			closeEvaluationFinishErrorsPopup () {
				this.evaluationFinishErrors.showPopup = false;
			}
		},
	};
</script>

<style scoped>

</style>